import React from 'react'
import { browserHistory, Route, Router } from 'react-router'
import Recherche from './Page/Recherche'
import Document from './Page/Document'
import Utils from 'EurestoFonction/Utils'

export default _ =>
  <Router history={browserHistory}>
    <Route path="/stock/documents" component={Recherche} />
    <Route path="/stock/document" component={Document} action={"add"} />
    <Route path="/stock/document/:id" component={Document} />
  </Router>


// WEBPACK FOOTER //
// ./app/App/Module/Stock/index.js